<template>
  <i-col
    :xl="fullsize ? undefined : 3"
    :md="fullsize ? undefined : 4"
    :sm="fullsize ? undefined : 6"
    :xs="fullsize ? undefined : 24"
    :class="`card-column ${fullsize ? 'home' : ''}`"
  >
    <Card dis-hover class="news-card">
      <img slot="title" v-if="typeof src === 'string'" :src="src" alt="bank news" loading="lazy" class="bank-image" />
      <img
        slot="title"
        v-if="typeof src !== 'string'"
        src="../assets/logo.png"
        alt="bank news"
        loading="lazy"
        class="bank-image"
      />
      <router-link :to="`news/${id}`" tag="a">
        {{ renderByI18n("title") }}
      </router-link>
    </Card>
  </i-col>
</template>

<style lang="scss">
.card-column.home {
  &:not(:last-child) {
    margin-bottom: 8px;
  }
}
.news-card {
  min-width: 100px;
  img {
    height: 150px;
  }
  a {
    color: #10a995;
    font-size: 16px;
    &:visited,
    &:focus,
    &:active {
      color: #10a995;
    }
    &:hover {
      color: #10a995;
    }
  }
}
.bank-image {
  object-fit: cover;
  width: 100%;
  min-height: 100%;
}
@media only screen and (max-width: 576px) {
  .card-column {
    margin: 7.5px 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>

<script>
export default {
  name: 'news-item',
  props: ['src', 'title', 'title_al', 'description', 'description_al', 'date', 'id', 'fullsize'],
  methods: {
    renderByI18n(property) {
      const field = this._i18n.locale === 'en' ? property : `${property}_al`;
      return this[field];
    },
  },
};
</script>
